import { ICommand, IDefineCommand, IQuery } from 'core-ts-types';
import { NotesConfigModel } from '../models/notes_config_model';

angular
  .module('data-ng-custom-text')
  .factory(
    'loadNotesConfigsCommand',
    (
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      ngNotesConfigModel: NotesConfigModel,
      log: any
    ): ICommand => {
      let activePromise: any = false;
      return defineCommandORM('loadNotesConfigsCommand', function loadNotesConfigsCommand(deferred) {
        if (!activePromise) {
          activePromise = $http
            .get('/config/featuretoggle/ssccampus-docs_notes')
            .then(({ data }: any) => {
              //modify data to fit STC calls
              const modifiedData = {
                is_active: data.data.enabled,
                last_enabled_dt: data.data.last_enabled_dt,
                name: data.data.name,
                nk: 'NOTES'
              };
              ngNotesConfigModel.write(modifiedData);
              activePromise = false;
              deferred.resolve(data);
            })
            .catch((e: any) => {
              log.issue('Failed to get notes config');
              activePromise = false;
              deferred.reject(e);
            });
          return activePromise;
        } else {
          return activePromise;
        }
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/data-ng-custom-text/src/commands/load_notes_config_command.ts